/**
 * Tutorial guidato della pagina Report → Pubblicità.
 *
 * Nessun preparativo: la pagina non ha schede né menu da aprire. Senza piattaforme collegate i blocchi
 * dei dati non esistono e i passi che li riguardano si saltano (missing: 'skip').
 */
const SCOPE = '[data-tour-scope="ads"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createAdsTourSteps() {
	return [
		{
			body: 'Qui vedi quanto spendi in pubblicità e quanto rende. La spesa arriva da sola ogni notte dalle piattaforme collegate (Google Ads, Meta, TikTok e Microsoft Ads), campagna per campagna.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Pubblicità',
		},
		{
			body: 'Stesso periodo e stesso confronto della Home: mese, trimestre, anno o due date.',
			key: 'period',
			placement: 'bottom',
			target: at('period'),
			title: 'Il periodo',
		},
		{
			body: 'Il ROAS complessivo divide le vendite di tutti i canali per la spesa: è il numero affidabile. Il ROAS dichiarato è quello delle piattaforme, che si attribuiscono anche vendite contate dalle altre. Il ROAS di pareggio è il minimo perché la pubblicità non si mangi tutto il margine: sotto, sei in perdita.',
			key: 'kpi',
			missing: 'skip',
			placement: 'bottom',
			target: at('kpi'),
			title: 'I numeri',
		},
		{
			body: 'Le barre sono la spesa, la linea le vendite: se la spesa sale e le vendite no, la pubblicità non sta rendendo.',
			key: 'trend',
			missing: 'skip',
			placement: 'top',
			target: at('trend'),
			title: 'Spesa e vendite',
		},
		{
			body: 'Ogni piattaforma con spesa, clic, costo per clic, conversioni e valore dichiarato.',
			key: 'sources',
			missing: 'skip',
			placement: 'top',
			target: at('sources'),
			title: 'Per piattaforma',
		},
		{
			body: 'Le campagne del periodo, dalla più costosa. In rosso quelle con il ROAS dichiarato sotto la soglia di pareggio. Dai tre puntini apri la campagna nella piattaforma.',
			key: 'campaigns',
			missing: 'skip',
			placement: 'top',
			target: at('campaigns'),
			title: 'Le campagne',
		},
		{
			body: 'Dal menu a tre puntini esporti le campagne e apri le impostazioni: lì colleghi le piattaforme e scegli se usare la spesa nel conto economico del report finanziario.',
			key: 'menu',
			placement: 'bottom',
			target: at('menu'),
			title: 'Export e impostazioni',
		},
	];
}
